"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const OsmosysConverter_1 = require("../../../../comps/OsmosysConverter");
exports.EmailCanvasConverterTabBody = ({ onStart, contentStr, onSuccess, onError, onChange, onClose, showSpinner, run, conversions, onStop, linkToPost, }) => {
    return (react_1.default.createElement(OsmosysConverter_1.OsmosysConverter, { contentStr: contentStr, run: run, onStart: onStart, onSuccess: onSuccess, onError: onError, onClose: onClose, onStop: onStop, onChange: onChange, showSpinner: showSpinner, conversions: conversions, linkToPost: linkToPost }));
};
//# sourceMappingURL=ConverterTabBody.js.map